//@flow

export const getAccountNumber = (win: WindowProxy) : ?string  => (win.document.cookie.match(/reece-account-number=([^;]+)*/) && win.document.cookie.match(/reece-account-number=([^;]+)*/)[1]) || undefined;

export const isMaxUser = (win: WindowProxy) : boolean => win.document.querySelector("[data-user-type='MAX_USER']");

export const toHTMLElement = (elem: ?HTMLElement) : HTMLElement => (((elem):any):HTMLElement);

export const getUserPostCode = (win: WindowProxy) : ?string => {
  const searchDiv : HTMLElement = win.document.querySelector("[data-user-postcode]");
  if (searchDiv) {
    return searchDiv.dataset.userPostcode;
  }
  return undefined;
};



// WEBPACK FOOTER //
// ./javascript/product-search-page/utils.js